import React from 'react';
import { Button, IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from 'theme/color-palette';
import styles from './RBSnackbar.style';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';
import classNames from 'classnames';

function RBSnackbar(props) {
	const {
		doOpen,
		msg,
		doClose,
		type = 'success',
		guidedBtn = false,
		transition = 'up',
		hideDuration = 2500,
		position = {
			vertical: 'bottom',
			horizontal: 'center'
		}
	} = props;
	const { TXT_SUCCESS, WARNING_TEXT_COLOR } = colors;
	const classes = styles(props);
	const { root, snackbarHidden } = classes;

	const cls = classNames({
		[root]: true,
		[snackbarHidden]: !doOpen
	});

	function SlideTransition(props) {
		return <Slide {...props} direction={transition} />;
	}

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		doClose(event);
	};

	let contentColor = type === 'success' ? TXT_SUCCESS : WARNING_TEXT_COLOR;

	if (type === 'dark') {
		contentColor = colors.WHITE;
	}

	return (
		<Snackbar
			id="rb-snackbar"
			className={cls}
			anchorOrigin={position}
			TransitionComponent={transition ? SlideTransition : Fade}
			open={doOpen}
			autoHideDuration={hideDuration}
			onClose={handleClose}
			message={<span style={{ color: contentColor }}>{msg}</span>}
			action={
				<React.Fragment>
					{guidedBtn && (
						<Button
							size="small"
							id="guidedBtn"
							onClick={(e) => {
								e.stopPropagation();
								guidedBtn.handleGuideBtn();
							}}
							className={classes.actionBtn}>
							{guidedBtn.name}
						</Button>
					)}
					<IconButton
						id="dismiss-snackbar"
						onClick={(e) => {
							e.stopPropagation();
							handleClose(e);
						}}>
						<CloseIcon fontSize="small" style={{ color: contentColor }} />
					</IconButton>
				</React.Fragment>
			}
		/>
	);
}

export default RBSnackbar;
